import React, { memo } from 'react'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid2'
import Typography from '@mui/material/Typography'
import usePageProps from 'hooks/usePageProps'
import Page from 'components/layout/Page'
import sx from './styles'

const TermsAndConditions = () => {
  const { data } = usePageProps()
  const { title, content } = data

  return (
    <Page>
      <Container
        maxWidth="md"
      >
        <Grid
          size={12}
          sx={sx.container}
        >
          <Typography
            variant="h1"
            align="center"
            sx={{ marginTop: 3, marginBottom: 5, paddingTop: 12 }}
          >
            {title?.rendered}
          </Typography>
          <div dangerouslySetInnerHTML={{ __html: content?.rendered }} />
        </Grid>
      </Container>
    </Page>

  )
}
export default memo(TermsAndConditions)
